module.exports = __webpack_public_path__ + "static/img/319.2160654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/319.jpg
// module id = r/rZ
// module chunks = 0